// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
export const pageview = (path: string, title: string, env: string): void => {
	{
		env == 'prod' &&
			window.gtag &&
			window.gtag('config', 'G-RPLXQHWRGB', {
				page_path: path,
				page_title: title,
			})
	}
}

type GTagEvent = {
	action: string
	category: string
	label: string
	value: number
}

// https://developers.google.com/analytics/devguides/collection/gtagjs/events
export const event = (
	{ action, category, label, value }: GTagEvent,
	env: string
): void => {
	{
		env == 'prod' &&
			window.gtag &&
			window.gtag('event', action, {
				event_category: category,
				event_label: label,
				value,
			})
	}
}
